<template>
  <div>
     <div id="modal" class="modal">
       <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container ">
          
          <div class="modal-header">
            <slot name="header">
              <h3>Registro de Visitante</h3>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="campo">
                <label for="nombreVisistante">Nombre</label>
                <input placeholder="Nombre" required id="nombreVisitante" type="text" v-model="input.nombreVisitante">
              </div>
              <div class="campo">
                <label for="apellidoVisistante">Apellido</label>
                <input placeholder="Apellido" required id="apellidoVisitante" type="text" v-model="input.apellidoVisitante">
              </div>
              <div class="campo">
                <label for="emailVisitante">Email</label>
                <input placeholder="nombre@gmail.com"  required id="emailVisitante" type="text" v-model="input.emailVisitante">
              </div>
              <div class="campo" >
                <label for="perfilVisitante">Perfil</label>
                <select v-model="input.perfilVisitante">
                  <option value="1">Administrativo</option>
                  <option value="2">Docente</option>
                  <option value="3">Estudiante</option>
                  <option value="4">Público General</option>
                </select>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="registrar">
                Registrar
              </button>
            </slot>
          </div>    
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import cabecera from '../components/cabecera.vue'
import pie from '../components/pie.vue'
import axios from 'axios'

import store from '../store'

export default {
  name: 'registro',
  components: {
    cabecera, 
    pie, 
  },
  data() {
    return {
      area: '',
      input: {
        nombreVisitante: "",
        apellidoVisitante: "",
        emailVisitante: "",
        perfilVisitante: "",
      },
      visitante:''
    }
  },

  methods:{
    updateVisitante (visitante) {
        store.commit('UPDATEVISITANTE', visitante)
      },
    registrar () {
      if(this.input.nombreVisitante!="" && this.input.emailVisitante!="" && this.input.perfilVisitante!=""){
          this.visitante="correoVisitante="+this.input.emailVisitante;
          //axios.post('http://localhost:3000/api/buscarVisitante/'+this.input.emailVisitante)
          axios.post('http://cimogsys.espoch.edu.ec:3000/api/buscarVisitante/'+this.input.emailVisitante)
          .then(response => {
            if(response=200){
              axios.put('http://cimogsys.espoch.edu.ec:3000/api/updateVisitante/mayo94os@hotmail.es')
              //axios.put('http://localhost:3000/api/updateVisitante/mayo94os@hotmail.es')
                .then(response => {
                  if(response=200){
                    //this.updateVisitante(this.input.nombreVisitante)
                    this.$router.push('/aplicacion/2')
                  }
                })
                .catch(e => {
                })
            }
          })
          .catch(e => {
            this.visitante="nombreVisitante="+this.input.nombreVisitante+" "+this.input.apellidoVisitante+
              "&correoVisitante="+this.input.emailVisitante+
              "&perfilVisitante="+this.input.perfilVisitante;
              axios.post('http://cimogsys.espoch.edu.ec:3000/api/newVisitante',this.visitante)
              //axios.post('http://localhost:3000/api/newVisitante',this.visitante)
              .then(response => {
                if(response=200){
                  this.updateVisitante(this.input.nombreVisitante)
                  this.$router.push('/aplicacion/2')
                }
              })
              .catch(e => {
              })
          })
      }
      else{
        this.$router.push('/aplicacion/2')
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log(this.$store.state.menuState)
  },

}
</script>
</script>
<style  lang="scss"  scoped src="../sass/formulario.scss"></style>



// WEBPACK FOOTER //
// src/components/registro.vue